import {
    Button,
    Card,
    CardActionArea,
    CardActions,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    IconButton,
    makeStyles,
    Slide,
    Typography,
    useMediaQuery,
    useTheme,
} from "@material-ui/core"
import React, { useEffect, useState } from "react"

import Cabecalho from "../Cabecalho"
import OperacaoTempoReal from "../../components/OperacaoTempoReal"

import { Settings } from "@material-ui/icons"
import { useSnackbar } from "../../utils/notificacoes"
import { useHistory, useParams } from "react-router-dom/cjs/react-router-dom.min"
import useParametros from "../../contexts/ParametrosContext"
import { RegistrarLogErro } from "../../services/clientefiel"
import { buscarMesaComPedidos, buscarMesas } from "../../services/integracao"
import useAppStore from "../../stores/AppStore"
import { Loading } from "../RegistradorDePedidos"
import { valorTotalDaMesa } from "../RegistradorDePedidos/functions"
import ListaPedidosMesa from "./ListaPedidosMesa"

const useStyles = makeStyles(theme => ({
    containerCabecalho: {
        marginTop: "4.3em",
    },
    containerCartoesMesa: {
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(140px, 1fr))",
        gap: "0.5rem",
        padding: "1rem",
        paddingTop: "0",
    },
    cartaoMesa: { height: "8rem", display: "flex", flexDirection: "column" },
    cartaoMesaDados: {
        flex: 5,
        textAlign: "center",
        alignItems: "center",
        padding: "0.5rem 1rem",
        gap: "1rem",
    },
    cartaoPedidoMesa: {
        height: "9rem",
        display: "flex",
        flexDirection: "column",
        marginRight: "0",
    },
    numeroMesa: {
        flex: 2,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    dadosMesa: {
        flex: 2,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
    },
    nomeMesa: {
        width: "40%",
        display: "flex",
        flexDirection: "column",
        "& > span": {
            display: "inline-flex",
            whiteSpace: "nowrap",
            overflow: "hidden",
            margin: "0 auto",
            width: "100%",
            justifyContent: "center",
        },
    },
    statusMesa: {
        padding: "2px 0",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "0.25rem",
        "& .numero-mesa-aberta": {
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "white",
            color: "#28a745",
            height: "1.5em",
            aspectRatio: "1 / 1",
            borderRadius: "100%",
        },
    },
    dadosPedidoMesa_container: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-around",
        alignItems: "center",
        flex: 4,
    },
    cartaoMesaDesconto: {
        padding: 0,
        flex: 2,
    },
    cartaoMesaDesconto_texto: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "white",
        width: "100%",
        height: "100%",
    },
    valorDesconto: {
        background: "#28a745",
    },
    semDesconto: {
        background: "#6c757d",
    },
    noPadding: { padding: 0 },
    barraDeControle: {
        position: "static",
        marginBottom: 0,

        "@media (max-width: 500px)": {
            position: "fixed",
            left: 0,
            right: 0,
            bottom: 0,
            width: "100%",
            display: "flex",
            gap: "0.75rem",
            padding: "0.75rem 1rem",
            backgroundColor: "white",
            // Fica ACIMA do conteúdo da página, mas ABAIXO da camada de modal
            // (theme.zIndex.modal = 1300). Assim, quando o diálogo "Fechar Mesa"
            // abre, ele cobre esta barra em vez de ficar atrás dela — antes estava
            // em `modal + 1` e escondia os botões Cancelar/Imprimir/Fechar do diálogo.
            zIndex: theme.zIndex.modal - 1,
            boxShadow: "0 -6px 18px rgba(0,0,0,0.12)",

            "& $botaoEstaticoAdd, & $botaoEstaticoClose": {
                position: "static",
                bottom: "auto",
                right: "auto",
                width: "100%",
                flex: 1,
                margin: 0,
                borderRadius: "5px",
            },
        },
    },
    botaoEstaticoAdd: {
        background: "#28a745",
        color: "white",
        position: "fixed",
        bottom: "1.75rem",
        right: "1.75rem",
        "& > span": {
            display: "flex",
            gap: "0.25rem",
        },
        "&:hover": {
            backgroundColor: "#2fc550",
        },
    },
    botaoEstaticoClose: {
        backgroundColor: "#007bff",
        color: "white",
        position: "fixed",
        bottom: "5.25rem",
        right: "1.75rem",
        "& > span": {
            display: "flex",
            gap: "0.25rem",
        },
        "&:hover": {
            backgroundColor: "#66b3ff",
        },
    },
    appBar: {
        "& > div": {
            justifyContent: "space-between",
        },
    },
    opcaoImpressoraLabel: {
        background: "white",
        borderRadius: "10px",
        padding: "2px 10px",
    },
    selecaoImpressora: {
        width: "200px",
        background: "white",
        opacity: 0.85,
    },
    botoesImpressoras: {
        backgroundColor: "gray",
        borderRadius: "10px",
        width: "100%",
        color: "white",
        "&:hover": {
            backgroundColor: "#A9A9A9",
        },
        [theme.breakpoints.down("xs")]: {
            flexDirection: "column",
        },
        "@media (max-width: 500px)": {
            display: "none",
        },
    },
    listaPedidos: {
        display: "flex",
        flexDirection: "column",
        gap: "1em",
        textAlign: "center",
    },
    botaoImprimir: {
        color: "#28a745",
    },
    botaoFecharMesa: {
        color: "white",
        background: "var(--cor-erro)",
        width: "49%",
        "&:hover": {
            backgroundColor: "var(--cor-erro-hover)",
        },
    },
    botaoFecharParcial: {
        width: "49%",
        backgroundColor: "#5dd55d",
        color: "white",
        "&:hover": {
            backgroundColor: "#75e575",
        },
    },
    botaoCancelarFechamentoMesa: {
        color: "white",
        backgroundColor: "var(--cor-erro)",
        "@media (max-width: 500px)": {
            width: "100%",
        },
        "&:hover": {
            backgroundColor: "var(--cor-erro-hover)",
        },
    },
    barraControle: {
        height: "3.5em",
        display: "flex",
        alignItems: "center",
        justifyContent: "right",
        paddingInline: "1em",
    },
    nomeDaMesa: {
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        overflow: "hidden",
    },
    numeroDaMesa: {
        minWidth: "8rem",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        width: "100%",
        "& > div": {
            display: "flex",
            alignItems: "center",
        },
    },
    valorFortmatado: {
        borderRadius: "10px",
        padding: "0em 0.4em",
        backgroundColor: "gray",
    },
    containerDePagamento: {
        display: "flex",
        gap: "0.5rem",
        justifyContent: "stretch",
    },
    cardItens: {
        display: "flex",
        gap: "1em",
        flexDirection: "column",
        marginBottom: "1em",
        height: "80%",
        backgroundColor: "#f4f4f4",
        overflow: "auto",
        padding: "0.5em",
        borderRadius: "10px",
        width: "100%",
    },
    paperCardPedido: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "5px 10px",
    },
    actionsConfiguracoes: {
        "& > button": {
            color: "white",
            "&:first-child": {
                backgroundColor: "var(--cor-erro)",
                "&:hover": {
                    backgroundColor: "#f46a6a",
                },
                "@media (max-width: 500px)": {
                    width: "10em",
                },
            },
            "&:last-child": {
                backgroundColor: "#28a745",
                "&:hover": {
                    backgroundColor: "#34d058",
                },
                "@media (max-width: 500px)": {
                    width: "10em",
                },
            },
        },
    },
    actionsCardPedidos: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",

        // Só os botões de ação com rótulo (ex.: "Adicionar Item"). IconButton fica de
        // fora: ele é um ícone solto, sem fundo, igual à impressora do Recebedor.
        "& > button:not(.MuiIconButton-root)": {
            color: "white",
            backgroundColor: "#007bff",
            "&:hover": {
                backgroundColor: "#66b3ff",
            },
        },
        "& > p": {
            cursor: "pointer",
            color: "#28a745",
        },
    },
    parametrosDeImpressao: {
        "@media (max-width: 500px)": {
            display: "none",
        },
    },
    containerCardPedido: {
        marginBottom: "10em",
        padding: "0.8rem",
        paddingLeft: 0,
        maxWidth: "100%",
        display: "flex",
        flexWrap: "wrap",
        gap: "0.5rem",
        boxSizing: "border-box",

        "@media (max-width: 500px)": {
            marginBottom: "6em",
        },
    },

    cardPedidoWrapper: {
        flex: "1 1 500px",
        minWidth: 500,
        maxWidth: 500,

        "@media (max-width: 500px)": {
            minWidth: "100%",
            flexBasis: "100%",
        },
    },

    cardPedido: {
        display: "flex",
        flexDirection: "column",
        height: "32em",
        width: "100%",
        minWidth: 0,
        backgroundColor: "white",
        padding: "1em",
        borderRadius: "1em",
        marginLeft: "0.5em",
        boxShadow: "0px 0px 10px 1px rgba(0, 0, 0, 0.2)",

        "@media (max-width: 500px)": {
            height: "auto",
            maxHeight: "32em",
        },
    },
    tituloPedido: {
        display: "flex",
        justifyContent: "space-between",
        padding: "0.5em 1em",
        width: "100%",
    },
    selecaoFormaDePagamento: {
        flex: 2,
        maxWidth: "24em",
        "@media (max-width: 500px)": {
            maxWidth: "13.4em",
        },
    },
    excluirFormaDePagamento: {
        "&:hover": {
            backgroundColor: "#f4f4f4",
        },
    },
}))

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />
})

const CardMesa = ({ mesa, setMesaSelecionada, atualizarMesas }) => {
    const classes = useStyles()
    let aberta = false
    if (Object.keys(mesa).length !== 1) {
        aberta = true
    }
    const totalMesa = valorTotalDaMesa(mesa ? mesa.pedidosMesa : null)

    const nomeMesa = mesa?.pedidosMesa?.length > 0 ? mesa?.pedidosMesa[0].cliente?.nome : "Anônimo"

    const handleClick = () => {
        setMesaSelecionada(mesa)
    }

    return (
        <Card
            className={classes.cartaoMesa}
            key={mesa.numeroMesa}
            onClick={() => {
                atualizarMesas()
            }}
        >
            <CardActionArea onClick={handleClick} className={classes.cartaoMesaDados}>
                <Typography variant="h3" component="span" className={classes.numeroMesa}>
                    {aberta ? null : mesa.numeroMesa}
                </Typography>
                {aberta ? (
                    <>
                        <div>
                            <Typography className={classes.nomeDaMesa}>{nomeMesa}</Typography>
                        </div>
                        <span style={{ margin: "auto" }}>
                            <Typography variant="body2" color="textSecondary" component="p">
                                {mesa.pedidosMesa?.length ? mesa.pedidosMesa?.length : 0} pedidos
                            </Typography>
                            <Typography variant="body1" component="span">
                                {Intl.NumberFormat("pt-BR", {
                                    style: "currency",
                                    currency: "BRL",
                                }).format(totalMesa)}
                            </Typography>
                        </span>
                    </>
                ) : null}
            </CardActionArea>
            <CardActions className={classes.noPadding}>
                {aberta ? (
                    <Typography
                        variant="button"
                        className={[classes.statusMesa, "botaoVerde naoArredondado"].join(" ")}
                    >
                        ABERTA <span className="numero-mesa-aberta">{mesa?.numeroMesa}</span>
                    </Typography>
                ) : (
                    <Typography
                        variant="button"
                        className={[classes.statusMesa, "botaoCinza naoArredondado"].join(" ")}
                    >
                        FECHADA
                    </Typography>
                )}
            </CardActions>
        </Card>
    )
}

const GerenciadorMesas = () => {
    const classes = useStyles()
    const history = useHistory()
    const autorizacao = localStorage.getItem("chaveSistema")
    const configuracoes = useAppStore(s => s.configuracoes)
    const estabelecimentoId = configuracoes.user.parametros.estabelecimento.id
    const podeVerHistoricos =
        configuracoes.user.perfil === "ADMINISTRADOR" ||
        configuracoes.user.perfil === "CLIENTEFIEL"
    const theme = useTheme()
    const mobile = useMediaQuery(theme.breakpoints.down("sm"))
    const { enqueueSnackbar } = useSnackbar()
    const alertStart = (msg, tipo) => {
        enqueueSnackbar(msg, { variant: tipo })
    }
    const parametros = useParametros()

    const { idMesa } = useParams()

    const [listaMesas, setListaMesas] = useState([])
    const [mesaSelecionada, setMesaSelecionada] = useState()
    const [somenteLeitura, setSomenteLeitura] = useState(false)
    const [open, setOpen] = useState(false)
    const [loading, setLoading] = useState(false)

    const handleClickOpen = () => {
        setOpen(true)
    }
    const handleClose = () => {
        window.location.reload()
        setOpen(false)
    }

    const numeracaoMesasParam = {
        primeira: parametros.PUBLIC_PRIMEIRA_MESA,
        ultima: parametros.PUBLIC_PRIMEIRA_MESA + parametros.PUBLIC_QUANTIDADE_MESA,
    }

    const primeiraMesa = Number(numeracaoMesasParam.primeira) || 1
    const ultimaMesa = Number(numeracaoMesasParam.ultima) || 50

    const mapaMesasAbertas = new Map(
        listaMesas
            .filter(mesa => typeof mesa.numeroMesa === "number")
            .map(mesa => [mesa.numeroMesa, mesa])
    )

    const todasMesas = Array.from({ length: ultimaMesa - primeiraMesa + 1 }, (_, index) => {
        const numeroMesa = primeiraMesa + index
        return mapaMesasAbertas.get(numeroMesa) || { numeroMesa }
    })

    const atualizarMesas = async () => {
        try {
            setLoading(true)
            if (estabelecimentoId) {
                const retorno = await buscarMesas(estabelecimentoId, autorizacao)

                if (retorno.retornoErro) {
                    alertStart(retorno.mensagem, "error")
                    return false
                }

                if (retorno.length === 0) {
                    setListaMesas([{ naoTem: true }])
                } else {
                    setListaMesas(retorno)
                }
            }
        } catch (error) {
            RegistrarLogErro(error, "handleOpenGerenciamentoMesa")
            alertStart("Procure os desenvolvedores! Erro: " + error.message, "error")
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        atualizarMesas()
    }, [])

    // Abre uma mesa específica pelo id do ControleMesa (sessão exata, não pelo número).
    // Mesa fechada (dataFechamento preenchida) entra em modo somente-visualização.
    const abrirMesaPorId = async id => {
        // Mesa aberta já carregada no grid: usa direto (já traz pedidosMesa da listagem),
        // evitando um novo fetch e a dependência do endpoint enriquecido.
        const mesaNoGrid = listaMesas.find(m => m && String(m.id) === String(id))
        if (mesaNoGrid) {
            setSomenteLeitura(!!mesaNoGrid.dataFechamento)
            setMesaSelecionada(mesaNoGrid)
            return
        }

        // Mesa antiga/fechada (fora do grid): busca a sessão por id no backend.
        try {
            setLoading(true)
            const mesa = await buscarMesaComPedidos(autorizacao, id)

            if (!mesa || mesa.retornoErro || mesa.codErro) {
                alertStart(mesa?.mensagem || "Sem permissão para visualizar esta mesa", "error")
                history.replace("/servicos/modulo/gerenciador-de-mesas")
                return
            }

            // Bloqueia mesa de outra loja (diferente da selecionada no painel), mesmo que o
            // usuário tenha permissão em várias — o backend já barra loja sem permissão.
            if (estabelecimentoId && mesa.estabelecimento?.id !== estabelecimentoId) {
                alertStart("Esta mesa pertence a outra loja.", "error")
                history.replace("/servicos/modulo/gerenciador-de-mesas")
                return
            }

            setSomenteLeitura(!!mesa.dataFechamento)
            setMesaSelecionada(mesa)
        } catch (error) {
            RegistrarLogErro(error, "abrirMesaPorId")
            alertStart("Procure os desenvolvedores! Erro: " + error.message, "error")
        } finally {
            setLoading(false)
        }
    }

    // Seleção de mesa: mesa com ControleMesa (id) navega por id na URL (fixa a sessão);
    // mesa ainda sem controle (só número) segue no fluxo em memória atual.
    const selecionarMesa = mesa => {
        if (mesa?.id) {
            history.push("/servicos/modulo/gerenciador-de-mesas/" + mesa.id)
        } else {
            setSomenteLeitura(false)
            setMesaSelecionada(mesa)
        }
    }

    const fecharMesaSelecionada = () => {
        setMesaSelecionada(undefined)
        setSomenteLeitura(false)
        if (idMesa) {
            history.push("/servicos/modulo/gerenciador-de-mesas")
        }
    }

    useEffect(() => {
        if (idMesa) {
            abrirMesaPorId(idMesa)
        } else if (mesaSelecionada?.id) {
            // Saiu de uma mesa aberta por id (voltar/fechar): limpa a seleção.
            setMesaSelecionada(undefined)
            setSomenteLeitura(false)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [idMesa])

    function isInIframe() {
        try {
            return window.self !== window.top
        } catch {
            return true
        }
    }

    return (
        <div
            style={{
                marginLeft: mobile || isInIframe() ? "" : "var(--drawer-width, 80px)",
                transition: "margin-left 0.2s ease",
            }}
        >
            {/* Dentro de iframe esta tela esconde o Cabeçalho (abaixo) — e com ele iriam
                embora o SSE, a rede de segurança, o som e a faixa de impressão pendente,
                deixando a aba sem receber pedido nenhum. Complementar exato à condição do
                Cabeçalho: fora do iframe ele já monta o mesmo núcleo, e montar os dois
                duplicaria o polling do QZ e o tratamento dos eventos à toa. */}
            {isInIframe() && <OperacaoTempoReal />}
            <Loading loading={loading} />
            <Dialog fullWidth={true} open={open} onClose={handleClose}>
                <DialogTitle>Configurações</DialogTitle>
                <DialogContent>
                    <Grid container spacing={1}>
                        {podeVerHistoricos && (
                            <Grid item container xs={12} sm={6} md={6}>
                                <Button
                                    fullWidth
                                    size="small"
                                    variant="contained"
                                    style={{ backgroundColor: "#007BFF", color: "white" }}
                                    onClick={() => history.push("/servicos/modulo/historico-mesas")}
                                >
                                    Visualizar histórico de mesas
                                </Button>
                            </Grid>
                        )}
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Fechar</Button>
                </DialogActions>
            </Dialog>
            {!isInIframe() && (
                <div className={classes.containerCabecalho}>
                    <Cabecalho
                        pagina={
                            mesaSelecionada?.numeroMesa
                                ? `Gerenciador de Mesas — Mesa ${mesaSelecionada.numeroMesa}`
                                : "Gerenciador de Mesas"
                        }
                    />
                </div>
            )}
            {/* Com uma mesa aberta escondemos o grid de cartões e o Gerenciador mostra
                a mesa inline (ListaPedidosMesa) logo abaixo do Cabeçalho, que permanece
                fixo no topo com o aceite/impressão sempre acessíveis. */}
            {!mesaSelecionada?.numeroMesa && (
                <>
                    <Grid container justifyContent="flex-end">
                        <IconButton onClick={handleClickOpen}>
                            <Settings />
                        </IconButton>
                    </Grid>
                    <div className={classes.containerCartoesMesa}>
                        {todasMesas.map(mesa => (
                            <CardMesa
                                mesa={mesa}
                                setMesaSelecionada={selecionarMesa}
                                atualizarMesas={atualizarMesas}
                            />
                        ))}
                    </div>
                </>
            )}
            <ListaPedidosMesa
                mesa={mesaSelecionada}
                handleClose={fecharMesaSelecionada}
                somenteLeitura={somenteLeitura}
                useStyles={useStyles}
                Transition={Transition}
                alertStart={alertStart}
                todasMesas={todasMesas}
                atualizarMesas={atualizarMesas}
            />
        </div>
    )
}

export default GerenciadorMesas
